import React from "react";
export default class CustomFields extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.renderCustomField = this.renderCustomField.bind(this);
  }

  handleChange(fieldData, e) {
    const { changeHandler } = this.props;

    if (fieldData.html_control == "boolean") {
      console.log(e.target.checked.toString());
      changeHandler(e.target.checked.toString(), fieldData.name);
    } else {
      changeHandler(e.target.value, fieldData.name);
    }
  }

  renderCustomField(customField, defaultValue, changeHandler) {
    const { store = {} } = this.props;
    const name = `${this.props.namePrefix}[${customField.name}]`;
    const field = this[`${customField.html_control}CustomField`](
      customField,
      name,
      defaultValue,
      changeHandler,
    );
    return (
      <div className="form-group">
        <label className="control-label">{customField.label}</label>
        {this.props.editable ? (
          <React.Fragment>{field}</React.Fragment>
        ) : (
          <div className="form-control">
            {customField.html_control == "boolean"
              ? store[customField.name] === "true" || store[customField.name] === "on"
                ? "Yes"
                : "No"
              : store[customField.name]}
          </div>
        )}
      </div>
    );
  }

  inputCustomField(fieldData, name, defaultValue) {
    return (
      <input
        data-testid="t-event-registr-shared--CustomF-text"
        className="form-control"
        name={name}
        value={defaultValue}
        type="text"
        onChange={this.handleChange.bind(this, fieldData)}
      />
    );
  }

  selectCustomField(fieldData, name, defaultValue) {
    const options = fieldData.entity_custom_values.map((value, index) => {
      return (
        <option key={index} value={value.name}>
          {value.name}
        </option>
      );
    });

    return (
      <select
        data-testid="t-event-registr-shared--CustomF-select-2"
        className="form-control"
        name={name}
        value={defaultValue}
        onChange={this.handleChange.bind(this, fieldData)}>
        <option key={"default"} value="">
          ----
        </option>
        {options}
      </select>
    );
  }

  booleanCustomField(fieldData, name, defaultValue) {
    return (
      <div>
        <input
          id={name}
          checked={defaultValue === "true" || defaultValue === "on"}
          type="checkbox"
          onChange={this.handleChange.bind(this, fieldData)}
          style={{ marginLeft: "16px" }}
        />
        {/* required to pass parameter to turn off checkbox */}
        <input
          data-testid="t-event-registr-shared--CustomF-hidden"
          name={name}
          type="hidden"
          value={defaultValue}
        />
      </div>
    );
  }

  render() {
    const { customField, store = {}, changeHandler } = this.props;
    const defaultValue = store[customField.name] || "";

    return <div>{this.renderCustomField(customField, defaultValue, changeHandler)}</div>;
  }
}
